import Module, { moduleInit, ViewLayer } from "../../../../framework/core/mvvm/module_base";
import { CaiChiTipsView } from "./caichi_tips_view";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("CaiChiTips")
export  class CaiChiTips extends Module<CaiChiTipsView,null> {

    constructor(){
        super();
        // this.layer = ViewLayer.Mid;
        this.viewType = CaiChiTipsView;
        this.windowPrefabResPath = 'package/yxx/caichi_tips';
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    onShow(args){
        this.view.effectAnim.play()
     }

     protected onButtonClickName(name : string) {
        switch (name) {
            case "EnterBtn":
                this.hide()
                break;
            default:
                break;
        }
    }

}
